import apiService from "../apiService";

const apiPortalPath = "/api/v1";

export const portalService = {
  POST_LOGIN: (params) => {
    return apiService.post(`${apiPortalPath}/admin-login`, params);
  },
  POST_CHECK_TOKEN: (params) => {
    return apiService.post(`${apiPortalPath}/admin-login/check_token`, params);
  },
  GET_MY_PROFILE: () => {
    return apiService.get(`${apiPortalPath}/admin/myProfile`);
  },
  POST_RESET_PASSWORD: (params) => {
    return apiService.post(`${apiPortalPath}/admin/reset-password`, params);
  },

  // ADMIN PERMISSION
  GET_ADMIN_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/admin${stringQuery ? stringQuery : ""}`
    );
  },
  GET_ADMIN_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/admin/${id}`);
  },
  PUT_ADMIN_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/admin/${id}`, params);
  },
  POST_ADMIN_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/admin`, params);
  },
  PUT_ADMIN_PASSWORD_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/admin/password/${id}`, params);
  },
  DELETE_ADMIN_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/admin/${id}`);
  },

  // ACTIVITY FORM HISTORY
  GET_ACTIVITY_FORM_HISTORY_BY_ACTIVITY_LIST: (id, stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/activity-form-history/activity/${id}${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  PUT_ACTIVITY_FORM_APPROVE_: (id, params) => {
    return apiService.put(
      `${apiPortalPath}/activity-form-history/approve/${id}`,
      params
    );
  },

  POST_ACTIVITY_FORM_CERTIFICATE_UPLOAD: (params) => {
    return apiService.post_formdata(
      `${apiPortalPath}/activity-form-history/upload-certificate`,
      params
    );
  },
  POST_ACTIVITY_FORM_ANSWER_EDIT: (params) => {
    return apiService.post_formdata(
      `${apiPortalPath}/activity-form-history/edit/answer`,
      params
    );
  },

  POST_ACTIVITY_FORM_REQUEST_EDIT: (params) => {
    return apiService.post(
      `${apiPortalPath}/activity-form-history/request-edit/validate`,
      params
    );
  },

  // ACTIVITY FORM
  GET_ACTIVITY_FORM_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/activity-form${stringQuery ? stringQuery : ""}`
    );
  },
  GET_ACTIVITY_FORM_ALERT: () => {
    return apiService.get(`${apiPortalPath}/activity-form/check-alert`);
  },
  GET_ACTIVITY_FORM_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/activity-form/${id}`);
  },
  POST_ACTIVITY_FORM_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/activity-form`, params);
  },
  POST_ACTIVITY_FORM_UPLOAD: (params) => {
    return apiService.post_formdata(
      `${apiPortalPath}/activity-form/upload`,
      params
    );
  },
  POST_ACTIVITY_FORM_UPLOAD_DELETE: (params) => {
    return apiService.post(
      `${apiPortalPath}/activity-form/upload/delete`,
      params
    );
  },
  POST_ACTIVITY_FORM_QUESTION_UPLOAD: (params) => {
    return apiService.post_formdata(
      `${apiPortalPath}/activity-form/upload/question`,
      params
    );
  },
  POST_ACTIVITY_FORM_QUESTION_MEDIA_DELETE: (params) => {
    return apiService.post(`${apiPortalPath}/activity/question/delete`, params);
  },
  PUT_ACTIVITY_FORM_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/activity-form/${id}`, params);
  },
  DELETE_ACTIVITY_FORM_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/activity-form/${id}`);
  },

  // ACTIVITY
  GET_ACTIVITY_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/activity${stringQuery ? stringQuery : ""}`
    );
  },
  GET_ACTIVITY_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/activity/${id}`);
  },
  POST_ACTIVITY_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/activity`, params);
  },
  POST_ACTIVITY_UPLOAD: (params) => {
    return apiService.post_formdata(`${apiPortalPath}/activity/upload`, params);
  },
  POST_ACTIVITY_UPLOAD_DELETE: (params) => {
    return apiService.post(`${apiPortalPath}/activity/upload/delete`, params);
  },
  POST_ACTIVITY_QUESTION_UPLOAD: (params) => {
    return apiService.post_formdata(
      `${apiPortalPath}/activity/upload/question`,
      params
    );
  },
  POST_ACTIVITY_QUESTION_MEDIA_DELETE: (params) => {
    return apiService.post(`${apiPortalPath}/activity/question/delete`, params);
  },
  PUT_ACTIVITY_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/activity/${id}`, params);
  },
  DELETE_ACTIVITY_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/activity/${id}`);
  },

  // SEAT BOOKING (กิจกรรมจองที่นั่ง)
  GET_SEAT_BOOKING_CONFIG: (id) => {
    return apiService.get(`${apiPortalPath}/seat-booking/admin/activity/${id}/config`);
  },
  PUT_SEAT_BOOKING_CONFIG: (id, params) => {
    return apiService.put(`${apiPortalPath}/seat-booking/admin/activity/${id}/config`, params);
  },
  GET_SEAT_BOOKING_SEATS: (id) => {
    return apiService.get(`${apiPortalPath}/seat-booking/admin/activity/${id}/seats`);
  },
  POST_SEAT_BOOKING_SEAT_IMPORT: (id, params) => {
    return apiService.post(`${apiPortalPath}/seat-booking/admin/activity/${id}/seats/import`, params);
  },
  GET_SEAT_BOOKING_PRESETS: () => {
    return apiService.get(`${apiPortalPath}/seat-booking/admin/seat-presets`);
  },
  POST_SEAT_BOOKING_PRESET_APPLY: (id, params) => {
    return apiService.post(`${apiPortalPath}/seat-booking/admin/activity/${id}/seat-preset`, params);
  },
  DELETE_SEAT_BOOKING_SEATS: (id) => {
    return apiService.delete(`${apiPortalPath}/seat-booking/admin/activity/${id}/seats`);
  },
  POST_SEAT_BOOKING_MAP_UPLOAD: (id, params) => {
    return apiService.post_formdata(`${apiPortalPath}/seat-booking/admin/activity/${id}/seat-map`, params);
  },
  DELETE_SEAT_BOOKING_MAP: (id) => {
    return apiService.delete(`${apiPortalPath}/seat-booking/admin/activity/${id}/seat-map`);
  },
  POST_SEAT_BOOKING_ACCOUNT_QR_UPLOAD: (id, params) => {
    return apiService.post_formdata(`${apiPortalPath}/seat-booking/admin/activity/${id}/account-qr`, params);
  },
  DELETE_SEAT_BOOKING_ACCOUNT_QR: (id) => {
    return apiService.delete(`${apiPortalPath}/seat-booking/admin/activity/${id}/account-qr`);
  },
  POST_SEAT_BOOKING_SEAT_BLOCK: (id, params) => {
    return apiService.post(`${apiPortalPath}/seat-booking/admin/activity/${id}/seats/block`, params);
  },
  POST_SEAT_BOOKING_SEAT_RELEASE: (id, params) => {
    return apiService.post(`${apiPortalPath}/seat-booking/admin/activity/${id}/seats/release`, params);
  },
  GET_SEAT_BOOKING_LIST: (id, stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/seat-booking/admin/activity/${id}/bookings${stringQuery ? stringQuery : ""}`
    );
  },
  POST_SEAT_BOOKING_ADMIN_CREATE: (id, params) => {
    return apiService.post_formdata(`${apiPortalPath}/seat-booking/admin/activity/${id}/bookings`, params);
  },
  POST_SEAT_BOOKING_IMPORT: (id, params) => {
    return apiService.post(`${apiPortalPath}/seat-booking/admin/activity/${id}/bookings/import`, params);
  },
  POST_SEAT_BOOKING_BULK_APPROVE: (params) => {
    return apiService.post(`${apiPortalPath}/seat-booking/admin/bookings/approve`, params);
  },
  GET_SEAT_BOOKING_DETAIL: (bookingId) => {
    return apiService.get(`${apiPortalPath}/seat-booking/admin/booking/${bookingId}`);
  },
  POST_SEAT_BOOKING_APPROVE: (bookingId) => {
    return apiService.post(`${apiPortalPath}/seat-booking/admin/booking/${bookingId}/approve`);
  },
  POST_SEAT_BOOKING_REJECT: (bookingId, params) => {
    return apiService.post(`${apiPortalPath}/seat-booking/admin/booking/${bookingId}/reject`, params);
  },
  POST_SEAT_BOOKING_UNDO: (bookingId, params) => {
    return apiService.post(`${apiPortalPath}/seat-booking/admin/booking/${bookingId}/undo`, params);
  },
  POST_SEAT_BOOKING_CANCEL: (bookingId, params) => {
    return apiService.post(`${apiPortalPath}/seat-booking/admin/booking/${bookingId}/cancel`, params);
  },
  POST_SEAT_BOOKING_CHECKIN: (bookingId, params) => {
    return apiService.post(`${apiPortalPath}/seat-booking/admin/booking/${bookingId}/checkin`, params);
  },
  POST_SEAT_BOOKING_CHECKIN_UNDO: (bookingId, params) => {
    return apiService.post(`${apiPortalPath}/seat-booking/admin/booking/${bookingId}/checkin/undo`, params);
  },

  // ACTIVITY HISTORY
  GET_ACTIVITY_HISTORY_BY_ACTIVITY_LIST: (id, stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/activity-history/activity/${id}${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_ACTIVITY_BY_CUSTOMER_LIST: (id, stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/activity-history/customer/${id}${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  PUT_ACTIVITY_HITORY: (id, params) => {
    return apiService.put(`${apiPortalPath}/activity-history/${id}`, params);
  },
  POST_ACTIVITY_HITORY_SCAN: (params) => {
    return apiService.post(
      `${apiPortalPath}/activity-history/scan/admin`,
      params
    );
  },
  POST_ACTIVITY_ANNOUNCEMEN_DETAIL: (params) => {
    return apiService.post(
      `${apiPortalPath}/activity-history/announcemen`,
      params
    );
  },
  POST_ACTIVITY_HISTORY_IMPORT: (params) => {
    return apiService.post_formdata(
      `${apiPortalPath}/activity-history/import`,
      params
    );
  },
  PUT_ACTIVITY_NOMAL_FORM_APPROVE: (id, params) => {
    return apiService.put(
      `${apiPortalPath}/activity-history/approve-normal-form/${id}`,
      params
    );
  },
  POST_ACTIVITY_QUESTION_EDIT: (params) => {
    return apiService.post_formdata(
      `${apiPortalPath}/activity-history/me/question`,
      params
    );
  },

  // BANNER
  GET_BANNER_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/banner${stringQuery ? stringQuery : ""}`
    );
  },
  GET_BANNER_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/banner/${id}`);
  },
  POST_BANNER_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/banner`, params);
  },
  POST_BANNER_UPLOAD: (params) => {
    return apiService.post_formdata(`${apiPortalPath}/banner/upload`, params);
  },
  PUT_BANNER_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/banner/${id}`, params);
  },
  DELETE_BANNER_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/banner/${id}`);
  },

  // CERTIFICATE
  GET_CERTIFICATE_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/certificate${stringQuery ? stringQuery : ""}`
    );
  },
  GET_CERTIFICATE_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/certificate/${id}`);
  },
  PUT_CERTIFICATE_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/certificate/${id}`, params);
  },
  POST_CERTIFICATE_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/certificate`, params);
  },
  POST_CERTIFICATE_GENERATE: (params) => {
    return apiService.post(`${apiPortalPath}/certificate/generate`, params);
  },
  GET_CERTIFICATE_GENERATE: (id) => {
    return apiService.get(`${apiPortalPath}/certificate/landing/${id}`);
  },
  POST_CERTIFICATE_UPLOAD: (params) => {
    return apiService.post_formdata(
      `${apiPortalPath}/certificate/upload`,
      params
    );
  },
  POST_CERTIFICATE_GENERATE_UPLOAD: (params) => {
    return apiService.post_formdata(
      `${apiPortalPath}/certificate/upload/generate`,
      params
    );
  },
  DELETE_CETIFICATE_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/certificate/${id}`);
  },
  GET_CERTIFICATE_GENERATE_HISTORY_BY_CERT_ID: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/certificate-generate-history${
        stringQuery ? stringQuery : ""
      }`
    );
  },

  // REWARD HISTORY activity
  GET_REWARD_HISTORY_BY_REWARD_LIST: (id, stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/reward-history/reward/${id}${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_REWARD_BY_CUSTOMER_LIST: (id, stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/reward-history/customer/${id}${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  POST_REWARD_HITORY_SCAN: (params) => {
    return apiService.post(
      `${apiPortalPath}/reward-history/scan/admin`,
      params
    );
  },

  // ASSESSMENT
  GET_ASSESSMENT_BY_QUESTION_LIST: (id, stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/assessment/question/${id}${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_ASSESSMENT_BY_QUESTION_ADMIN_LIST: (id, stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/assessment/question/admin/${id}${
        stringQuery ? stringQuery : ""
      }`
    );
  },

  // CUSTOMER
  GET_CUSTOMER_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/customer${stringQuery ? stringQuery : ""}`
    );
  },
  GET_CUSTOMER_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/customer/${id}`);
  },
  DELETE_CUSTOMER_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/customer/${id}`);
  },
  GET_CUSTOMER_EDIT_LOG: (id) => {
    return apiService.get(`${apiPortalPath}/customer-info-log/customer/${id}`);
  },
  PUT_CUSTOMER_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/customer/admin/edit/${id}`, params);
  },
  PUT_CUSTOMER_EDIT_LOG: (id, params) => {
    return apiService.put(`${apiPortalPath}/customer-info-log/${id}`, params);
  },

  // NEW
  GET_NEW_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/new${stringQuery ? stringQuery : ""}`
    );
  },
  GET_NEW_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/new/${id}`);
  },
  POST_NEW_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/new`, params);
  },
  POST_NEW_UPLOAD: (params) => {
    return apiService.post_formdata(`${apiPortalPath}/new/upload`, params);
  },
  PUT_NEW_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/new/${id}`, params);
  },
  DELETE_NEW_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/new/${id}`);
  },

  // BUSINESS_UNIT
  GET_BUSINESS_UNIT_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/business-unit${stringQuery ? stringQuery : ""}`
    );
  },
  GET_BUSINESS_UNIT_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/business-unit/${id}`);
  },
  POST_BUSINESS_UNIT_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/business-unit`, params);
  },
  PUT_BUSINESS_UNIT_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/business-unit/${id}`, params);
  },
  DELETE_BUSINESS_UNIT_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/business-unit/${id}`);
  },
  DELETE_SOFT_BUSINESS_UNIT_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/business-unit/${id}/soft`);
  },

  // BRANCH
  GET_BRANCH_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/branch${stringQuery ? stringQuery : ""}`
    );
  },
  GET_BRANCH_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/branch/${id}`);
  },
  POST_BRANCH_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/branch`, params);
  },
  PUT_BRANCH_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/branch/${id}`, params);
  },
  DELETE_BRANCH_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/branch/${id}`);
  },

  // PRODUCT WARRANTEE
  GET_PRODUCT_WARRANTEE_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/product-warrantee${stringQuery ? stringQuery : ""}`
    );
  },
  DOWNLOAD_PRODUCT_WARRANTEE_EXCEL: (stringQuery, onProgress) => {
    return apiService.getDownload(
      `${apiPortalPath}/product-warrantee/download-excel${
        stringQuery ? stringQuery : ""
      }`,
      null,
      onProgress
    );
  },
  GET_PRODUCT_WARRANTEE_BY_CUSTOMER_LIST: (id, stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/product-warrantee/customer/${id}${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_PRODUCT_WARRANTEE_BY_SERIAL_NO: (id) => {
    return apiService.get(`${apiPortalPath}/product-warrantee/serial-no/${id}`);
  },
  GET_PRODUCT_WARRANTEE_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/product-warrantee/${id}`);
  },
  POST_PRODUCT_WARRANTEE_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/product-warrantee`, params);
  },
  POST_PRODUCT_WARRANTEE_APPROVAL: (params) => {
    return apiService.post(
      `${apiPortalPath}/product-warrantee/approval`,
      params
    );
  },
  POST_PRODUCT_WARRANTEE_IMPORT_JSON: (params) => {
    return apiService.post(
      `${apiPortalPath}/product-warrantee/import-json-admin`,
      params
    );
  },
  POST_PRODUCT_WARRANTEE_JSON_CREATE: (params) => {
    return apiService.post(
      `${apiPortalPath}/product-warrantee/import-json/detail`,
      params
    );
  },
  PUT_PRODUCT_WARRANTEE_SLIP_IMG_DELETE: (id, params) => {
    return apiService.put(
      `${apiPortalPath}/product-warrantee/delete-slip-img/${id}`,
      params
    );
  },
  POST_PRODUCT_WARRANTEE_UPLOAD: (params) => {
    return apiService.post_formdata(
      `${apiPortalPath}/product-warrantee/import-json-file`,
      params
    );
  },
  POST_PRODUCT_WARRANTEE_UPLOAD_IMAGE: (params) => {
    return apiService.post_formdata(
      `${apiPortalPath}/product-warrantee/upload/admin`,
      params
    );
  },
  POST_PRODUCT_WARRANTEE_REGIS_UPLOAD_IMAGE: (params) => {
    return apiService.post(
      `${apiPortalPath}/product-warrantee/upload/member`,
      params
    );
  },
  PUT_PRODUCT_WARRANTEE_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/product-warrantee/${id}`, params);
  },
  DELETE_PRODUCT_WARRANTEE_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/product-warrantee/${id}`);
  },
  GET_PRODUCT_WARRANTEE_ACTION_LOG: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/product-warrantee-action-log${
        stringQuery ? stringQuery : ""
      }`
    );
  },

  GET_PRODUCT_DEP_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/product-dep${stringQuery ? stringQuery : ""}`
    );
  },

  // QUESTION
  GET_QUESTION_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/question${stringQuery ? stringQuery : ""}`
    );
  },
  GET_QUESTION_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/question/${id}`);
  },
  POST_QUESTION_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/question`, params);
  },
  POST_QUESTION_UPLOAD: (params) => {
    return apiService.post_formdata(`${apiPortalPath}/question/upload`, params);
  },
  PUT_QUESTION_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/question/${id}`, params);
  },
  DELETE_QUESTION_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/question/${id}`);
  },

  // REWARD
  GET_REWARD_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/reward${stringQuery ? stringQuery : ""}`
    );
  },
  GET_REWARD_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/reward/${id}`);
  },
  POST_REWARD_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/reward`, params);
  },
  POST_REWARD_UPLOAD: (params) => {
    return apiService.post_formdata(`${apiPortalPath}/reward/upload`, params);
  },
  PUT_REWARD_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/reward/${id}`, params);
  },
  DELETE_REWARD_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/reward/${id}`);
  },

  // REWARD HISTORY
  GET_REWARD_HISTORY_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/reward-history/${stringQuery ? stringQuery : ""}`
    );
  },
  GET_REWARD_HISTORY_BY_CUSTOMER_LIST: (id, stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/reward-history/customer/${id}${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  PUT_REWARD_HISTORY_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/reward-history/${id}`, params);
  },
  // reward e-voucher
  GET_REWARD_VOUCHER: (id, stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/reward-e-voucher/reward/${id}${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_REWARD_VOUCHER_PRODUCT: (id, stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/reward-e-voucher/reward/${id}/product-list${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_REWARD_E_VORCHER: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/reward-e-voucher/${stringQuery ? stringQuery : ""}`
    );
  },
  GET_REWARD_E_VORCHER_STATISTIC_STATUS: (id) => {
    return apiService.get(
      `${apiPortalPath}/reward-e-voucher/reward/${id}/statistic-status`
    );
  },
  POST_REWARD_E_VOUCHER_ADMIN_REDEEM: (params) => {
    return apiService.post(
      `${apiPortalPath}/reward-e-voucher/redeem/admin`,
      params
    );
  },

  // LUCKY DRAW
  GET_LUCKY_DRAW_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/luckydraw-reward${stringQuery ? stringQuery : ""}`
    );
  },
  GET_LUCKY_DRAW_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/luckydraw-reward/${id}`);
  },
  POST_LUCKY_DRAW_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/luckydraw-reward`, params);
  },
  POST_LUCKY_DRAW_UPLOAD: (params) => {
    return apiService.post_formdata(
      `${apiPortalPath}/luckydraw-reward/upload`,
      params
    );
  },
  PUT_LUCKY_DRAW_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/luckydraw-reward/${id}`, params);
  },
  DELETE_LUCKY_DRAW_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/luckydraw-reward/${id}`);
  },

  // LUCKY DRAW History
  GET_LUCKY_DRAW_HISTORY_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/luckydraw-reward-history${
        stringQuery ? stringQuery : ""
      }`
    );
  },

  // STATISTIC
  GET_SYSTEM_OVERVIEW: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/statistic/overview/system${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_SYSTEM_OVERVIEW_PERIOD: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/statistic/overview/system/period${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_CUSTOMER_OVERVIEW: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/statistic/overview/customer${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_PRODUCT_WARRANTY_OVERVIEW: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/statistic/overview/product-warranty${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_ACTIVITY_HISTORY_OVERVIEW: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/statistic/overview/activity-history${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_REWARD_HISTORY_OVERVIEW: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/statistic/overview/reward-history${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_E_WARRANTY_OVERVIEW_STATUS: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/statistic/overview/e-warranty/status${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_E_WARRANTY_OVERVIEW_DEALER: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/statistic/overview/e-warranty/dealer${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_E_WARRANTY_OVERVIEW_DEALER_PRODUCT_DEP: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/statistic/overview/e-warranty/dealer/product-dep${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_RELINK_OVERVIEW: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/statistic/overview/relink${
        stringQuery ? stringQuery : ""
      }`
    );
  },

  // PDPA
  GET_PDPA_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/pdpa${stringQuery ? stringQuery : ""}`
    );
  },
  GET_PDPA_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/pdpa/${id}`);
  },
  POST_PDPA_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/pdpa`, params);
  },
  PUT_PDPA_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/pdpa/${id}`, params);
  },
  DELETE_PDPA_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/pdpa/${id}`);
  },

  // PDPA_HISTORY
  GET_PDPA_HISTORY_LIST_BY_PDPA_ID: (id, stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/pdpa-history/pdpa/${id}${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_PDPA_HISTORY_LIST_BY_CUSTOMER_ID: (id, stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/pdpa-history/customer/${id}${
        stringQuery ? stringQuery : ""
      }`
    );
  },

  // PERMISSION
  GET_PERMISSION_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/permission${stringQuery ? stringQuery : ""}`
    );
  },
  GET_MY_PERMISSION_DETAIL: () => {
    return apiService.get(`${apiPortalPath}/permission/me`);
  },
  GET_PERMISSION_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/permission/${id}`);
  },
  POST_PERMISSION_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/permission`, params);
  },
  PUT_PERMISSION_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/permission/${id}`, params);
  },
  DELETE_PERMISSION_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/permission/${id}`);
  },

  // NOTIFICATION
  POST_NOTIFICATION_SENT: (params) => {
    return apiService.post(
      `${apiPortalPath}/notification-history/send`,
      params
    );
  },
  POST_POPUP_SENT: (params) => {
    return apiService.post(`${apiPortalPath}/popup-history/send`, params);
  },

  // ORGANIZATION
  GET_ORGANIZATION_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/organization${stringQuery ? stringQuery : ""}`
    );
  },
  GET_ORGANIZATION_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/organization/${id}`);
  },
  POST_ORGANIZATION_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/organization`, params);
  },
  PUT_ORGANIZATION_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/organization/${id}`, params);
  },
  DELETE_ORGANIZATION_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/organization/${id}`);
  },
  GET_ORGANIZATION_ACTION_LOG: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/organization-action-log${
        stringQuery ? stringQuery : ""
      }`
    );
  },

  // CORPERATE PRODUCT SET (Draft → Pending Approve → Approved)
  GET_CORPERATE_PRODUCT_SET_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/corperate-product-set${stringQuery ? stringQuery : ""}`
    );
  },
  GET_CORPERATE_PRODUCT_SET_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/corperate-product-set/${id}`);
  },
  GET_CORPERATE_PRODUCT_SET_ACTION_LOG: (id) => {
    return apiService.get(
      `${apiPortalPath}/corperate-product-set/${id}/action-log`
    );
  },
  POST_CORPERATE_PRODUCT_SET_CHECK_SERIAL: (params) => {
    return apiService.post(
      `${apiPortalPath}/corperate-product-set/check-serial`,
      params
    );
  },
  POST_CORPERATE_PRODUCT_SET_DETAIL: (params) => {
    return apiService.post_formdata(
      `${apiPortalPath}/corperate-product-set`,
      params
    );
  },
  PUT_CORPERATE_PRODUCT_SET_SAVE_DRAFT: (id, params) => {
    return apiService.put_formdata(
      `${apiPortalPath}/corperate-product-set/${id}`,
      params
    );
  },
  PUT_CORPERATE_PRODUCT_SET_SEND_APPROVE: (id, params) => {
    return apiService.put_formdata(
      `${apiPortalPath}/corperate-product-set/${id}/send-approve`,
      params
    );
  },
  PUT_CORPERATE_PRODUCT_SET_APPROVE: (id, params) => {
    return apiService.put_formdata(
      `${apiPortalPath}/corperate-product-set/${id}/approve`,
      params
    );
  },
  PUT_CORPERATE_PRODUCT_SET_REJECT: (id) => {
    return apiService.put(
      `${apiPortalPath}/corperate-product-set/${id}/reject`
    );
  },

  POST_CUSTOMER_UNLINK: (params) => {
    return apiService.post(
      `${apiPortalPath}/customer/sync/unlink-line`,
      params
    );
  },

  // BOOKING
  GET_BOOKING_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/booking${stringQuery ? stringQuery : ""}`
    );
  },
  GET_BOOKING_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/booking/${id}`);
  },
  POST_BOOKING_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/booking`, params);
  },
  PUT_BOOKING_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/booking/${id}`, params);
  },
  DELETE_BOOKING_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/booking/${id}`);
  },

  // HOLIDAY
  GET_HOLIDAY_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/holiday${stringQuery ? stringQuery : ""}`
    );
  },
  GET_HOLIDAY_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/holiday/${id}`);
  },
  POST_HOLIDAY_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/holiday`, params);
  },
  PUT_HOLIDAY_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/holiday/${id}`, params);
  },
  DELETE_HOLIDAY_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/holiday/${id}`);
  },

  // TIMESLOT
  GET_TIME_SLOT_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/time-slot${stringQuery ? stringQuery : ""}`
    );
  },
  GET_TIME_SLOT_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/time-slot/${id}`);
  },
  POST_TIME_SLOT_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/time-slot`, params);
  },
  POST_TIME_SLOT_BOOKING: (params) => {
    return apiService.post(`${apiPortalPath}/time-slot/booking`, params);
  },
  PUT_TIME_SLOT_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/time-slot/${id}`, params);
  },
  DELETE_TIME_SLOT_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/time-slot/${id}`);
  },

  // SHOWROOM
  GET_SHOWROOM_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/showroom-visit${stringQuery ? stringQuery : ""}`
    );
  },
  GET_SHOWROOM_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/showroom-visit/${id}`);
  },
  POST_SHOWROOM_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/showroom-visit`, params);
  },
  PUT_SHOWROOM_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/showroom-visit/${id}`, params);
  },
  DELETE_SHOWROOM_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/showroom-visit/${id}`);
  },

  // BOOKING EMAIL CONFIG
  GET_BOOKING_EMAIL_CONFIG_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/booking-email-config${stringQuery ? stringQuery : ""}`
    );
  },
  GET_BOOKING_EMAIL_CONFIG_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/booking-email-config/${id}`);
  },
  POST_BOOKING_EMAIL_CONFIG_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/booking-email-config`, params);
  },
  PUT_BOOKING_EMAIL_CONFIG_UPDATE: (id, params) => {
    return apiService.put(
      `${apiPortalPath}/booking-email-config/${id}`,
      params
    );
  },
  DELETE_BOOKING_EMAIL_CONFIG_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/booking-email-config/${id}`);
  },

  GET_SHORTCUT_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/shortcut${stringQuery ? stringQuery : ""}`
    );
  },
  PUT_SHORTCUT_DETAIL: (id, params) => {
    return apiService.put(`${apiPortalPath}/shortcut/${id}`, params);
  },

  // MAIN TASK
  GET_MAIN_TASK_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/main-task${stringQuery ? stringQuery : ""}`
    );
  },
  GET_MAIN_TASK_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/main-task/${id}`);
  },
  POST_MAIN_TASK_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/main-task`, params);
  },
  PUT_MAIN_TASK_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/main-task/${id}`, params);
  },
  DELETE_MAIN_TASK_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/main-task/${id}`);
  },

  // SUB TASK
  GET_SUB_TASK_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/sub-task${stringQuery ? stringQuery : ""}`
    );
  },
  GET_SUB_TASK_BY_MAIN_TASK_ID: (id) => {
    return apiService.get(`${apiPortalPath}/sub-task/main-task-id/${id}`);
  },
  GET_SUB_TASK_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/sub-task/${id}`);
  },
  POST_SUB_TASK_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/sub-task`, params);
  },
  PUT_SUB_TASK_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/sub-task/${id}`, params);
  },
  DELETE_SUB_TASK_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/sub-task/${id}`);
  },

  // INSTRUMENT
  GET_INSTRUMENT_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/instrument${stringQuery ? stringQuery : ""}`
    );
  },
  GET_INSTRUMENT_BY_CUS_ID_LIST: (id, stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/instrument/customer/${id}${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_INSTRUMENT_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/instrument/${id}`);
  },
  POST_INSTRUMENT_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/instrument`, params);
  },
  PUT_INSTRUMENT_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/instrument/${id}`, params);
  },
  DELETE_INSTRUMENT_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/instrument/${id}`);
  },

  // MEDIA
  POST_SURVEY_UPLOAD_MEDIA: (params, callback) => {
    return apiService.post_formdata(
      `${apiPortalPath}/media/upload/survey`,
      params,
      callback
    );
  },
  POST_PRODUCT_WARRANTY_UPLOAD_MEDIA: (params, callback) => {
    return apiService.post_formdata(
      `${apiPortalPath}/media/upload/product-warranty`,
      params,
      callback
    );
  },
  DELETE_MEDIA_BY_PATH: (params) => {
    return apiService.post(`${apiPortalPath}/media/delete`, params);
  },
  DELETE_MEDIA_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/media/${id}`);
  },

  // ROOM MUSIC HALL AND MUSIC PRACTICE
  GET_ROOM_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/room${stringQuery ? stringQuery : ""}`
    );
  },

  // ROOM MUSIC HALL BOOKING
  GET_ROOM_BOOKING_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/room-booking${stringQuery ? stringQuery : ""}`
    );
  },
  GET_ROOM_BOOKING_PAYMENT_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/room-booking/payments/list${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_ROOM_BOOKING_DETAIL: (id) => {
    return apiService.get(`${apiPortalPath}/room-booking/${id}`);
  },
  DELETE_ROOM_BOOKING: (id) => {
    return apiService.delete(`${apiPortalPath}/room-booking/${id}`);
  },
  GET_ROOM_BOOKING_SLIP_DOWNLOAD: (stringQuery) => {
    return apiService.getDownload(
      `${apiPortalPath}/room-booking/payments/slips/download${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  POST_ROOM_BOOKING_CREATE: (params) => {
    return apiService.post(`${apiPortalPath}/room-booking`, params);
  },
  POST_ROOM_BOOKING_SLIP_UPLOAD_MEDIA: (params, callback) => {
    return apiService.post_formdata(
      `${apiPortalPath}/media/upload/slip`,
      params,
      callback
    );
  },
  PUT_ROOM_BOOKING_UPDATE: (id, params) => {
    return apiService.put(`${apiPortalPath}/room-booking/${id}`, params);
  },
  PUT_ROOM_BOOKING_SLIP_IMG_DELETE: (id, params) => {
    return apiService.put(
      `${apiPortalPath}/room-booking/delete-slip-img/${id}`,
      params
    );
  },
  PATCH_ROOM_BOOKING_ADVANCH_BOOKING: (id, params) => {
    return apiService.patch(
      `${apiPortalPath}/room-booking/${id}/advance-booking`,
      params
    );
  },
  PATCH_ROOM_BOOKING_PAYMENT_ACTKNOWLEDGE: (id, params) => {
    return apiService.patch(
      `${apiPortalPath}/room-booking/${id}/payment-approve`,
      params
    );
  },
  PATCH_ROOM_BOOKING_EVENT_DATE: (id, params) => {
    return apiService.patch(
      `${apiPortalPath}/room-booking/${id}/event-date`,
      params
    );
  },
  PATCH_ROOM_BOOKING_EVENT_STATUS: (id, params) => {
    return apiService.patch(
      `${apiPortalPath}/room-booking/${id}/event-status`,
      params
    );
  },
  PATCH_ROOM_BOOKING_ADMIN_RECEIPT: (id, params) => {
    return apiService.patch(
      `${apiPortalPath}/room-booking/${id}/admin/receipt`,
      params
    );
  },

  // ROOM AVAILABILITY
  GET_ROOM_AVAILABILITY_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/room-availability${stringQuery ? stringQuery : ""}`
    );
  },
  POST_ROOM_AVAILABILITY_DETAIL: (params) => {
    return apiService.post(`${apiPortalPath}/room-availability`, params);
  },
  DELETE_ROOM_AVAILABILITY_DETAIL: (id) => {
    return apiService.delete(`${apiPortalPath}/room-availability/${id}`);
  },

  GET_EQUIPMENT_LIST: (queryString) => {
    return apiService.get(
      `${apiPortalPath}/equipment${queryString ? queryString : ""}`
    );
  },

  // ACCOUNTING
  GET_ACCOUNTING_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/accounting${stringQuery ? stringQuery : ""}`
    );
  },
  GET_ACCOUNTING_REPORT_BY_ROOM_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/accounting/report/by-room${
        stringQuery ? stringQuery : ""
      }`
    );
  },
  GET_ACCOUNTING_REPORT_BY_MONTH_LIST: (stringQuery) => {
    return apiService.get(
      `${apiPortalPath}/accounting/report/by-month${
        stringQuery ? stringQuery : ""
      }`
    );
  },
};
